var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.2C20.8 7 20.8 8.3 20 9L17.2 11.8L9.4 4L12.2 1.2C13 0.4 14.3 0.4 15 1.2L16.8 3L19.8 0L21.2 1.4L18.2 4.4L20 6.2ZM14.2 12L12.8 10.6L10 13.4L7.9 11.3L10.7 8.5L9.3 7.1L6.5 9.9L5 8.5L2.2 11.3C1.4 12.1 1.4 13.4 2.2 14.1L4 15.9L0 19.9L1.4 21.3L5.4 17.3L7.2 19.1C8 19.9 9.3 19.9 10 19.1L12.8 16.3L11.4 14.9L14.2 12Z",
    fill: "#00A86B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.e82485f5bd66f05dc7261c022c129848.svg";
export { ForwardRef as ReactComponent };